import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './Heading.module.scss';
import { BRAND } from '../../constants/brand';

type HeadingLevels = 1 | 2 | 3 | 4 | 5 | 6;

interface HeadingProps {
  className?: string;
  level: HeadingLevels;
  noStyles?: boolean;
  styledAs?: HeadingLevels;
  id?: string;
}

const Heading: FunctionComponent<HeadingProps> = ({
  children,
  className,
  level,
  styledAs,
  noStyles = false,
}) => {
  const headingClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-heading`,
    className,
    {
      [styles.heading]: !noStyles,
      [styles[`level-${level}`]]: !noStyles && !styledAs,
      [styles[`level-${styledAs}`]]: !noStyles && styledAs,
    },
  );

  const HeadingTag = `h${level}`;

  // @ts-ignore
  return <HeadingTag className={headingClass}>{children}</HeadingTag>;
};

export default Heading;
